exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".not-found-page__img-container {\n  max-width: 700px;\n  padding-top: 20px;\n  margin: 0 auto;\n  width: 100%;\n  overflow: hidden;\n}\n.not-found-page__img-container img {\n  width: 100%;\n}", ""]);

